import ReadOnlyField from "../../../../../Forms/ReadOnly/ReadOnlyField";

const BranchInfoSection = ({ form }) => (
  <div className="grid grid-cols-2 gap-4 mb-6">
    <ReadOnlyField label="Sucursal Origen" value={form.originBranchName} />
    <ReadOnlyField label="Sucursal Destino" value={form.destinationBranchName} />
  </div>
);

export default BranchInfoSection;
